import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HomeService } from 'src/app/_services/home.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Output() donate = false;
    
    constructor(private homeService: HomeService) {
        homeService.SharingData.subscribe((res: any) => {
            this.donate = res;
        })
    }

    ngOnInit(): void {
    }

    onSubmit() {
        console.log('Je suis dans le submit');
        this.homeService.getDonateAction(true)
    } 
}
